import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SkeletonGroup: FunctionComponent<Props> = ({
    align = 'stretch',
    children,
    className = '',
    direction = 'column',
    gap = 'md',
    testId = TEST_ID
}) => {
    const classes = [
        styles.group,
        styles[`direction-${direction}`],
        styles[`gap-${gap}`],
        styles[`align-${align}`],
        className
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={classes} data-testid={testId}>
            {children}
        </div>
    );
};

export default SkeletonGroup;
